import editable from './editable'
export default {
  editable,
}
